import { render } from "./Form.vue?vue&type=template&id=e32f83d2"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/File/Form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e32f83d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e32f83d2', __exports__)) {
    api.reload('e32f83d2', __exports__)
  }
  
  module.hot.accept("./Form.vue?vue&type=template&id=e32f83d2", () => {
    api.rerender('e32f83d2', render)
  })

}


export default __exports__